<template>
  <div>
    <div style="margin: 20px">انتخاب مدارسي كه قصد تدريس در آنها را داريد:</div>
    <div v-if="isMobile">
      <v-card v-for="item in items" :key="item.FSerial">
        <v-card-title class="info-detail" style="padding-right:50px ;">
          <v-switch color="primary" @change="toggle(item, $event !== null)"></v-switch>
          <div class="text-center">
            {{ item.FName }}
          </div>
        </v-card-title>
        <div class="contain" :style="[
          selected.indexOf(item) != -1
            ? { 'background-color': '#00d10040' }
            : '',
        ]">
          <app-row icon="hashtag" title="کد : " :value="item.FCode" />
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-data-table v-model="selected" :headers="headers" :items="items" item-key="FSerial" show-select
        :no-data-text="tableText" class="elevation-1 rounded2" :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
        }">
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
    </div>
    <app-actions @nextStep="nextStep" :showCancel="true" @prevStep="prevStep"></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
import DetailRow from "@/components/DetailRow";
export default {
  components: {
    appActions: Actions,
    appRow: DetailRow,
  },
  data() {
    return {
      selected: [],

      headers: [
        {
          text: "",
          value: "FSerial",
          width: "0px",
          sortable: false,
        },
        {
          text: "کد",
          value: "FCode",
          width: "10%",
        },
        {
          text: "نام مدرسه",
          value: "FName",
          width: "90%",
        },
      ],
    };
  },
  props: ["items"],
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  methods: {
    nextStep() {
      if (this.selected.length == 0) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "مدرسه ای برای تدریس انتخاب نشده است."
        );

        return;
      } else {
        this.$emit("nextStep", this.selected);
      }
    },
    prevStep() {
      this.$emit("prevStep");
    },
    toggle(item, value) {
      if (value) {
        this.selected.push(item);
      } else {
        const index = array.indexOf(item);
        if (index > -1) {
          this.selected.splice(index, 1);
        }
      }
    },
  },
};
</script>
